import type { ExtractPropTypes, PropType } from "vue";
import type { UiTypes } from "various-ui";

export const UiSelectPropsOption = {
    placeholder: { type: String }, //* 提示文本
    modelValue: { type: String, required: true }, //* 选中项绑定值
    disabled: { type: Boolean, default: false }, //* 选择器是否禁用
    readonly: { type: Boolean, default: false }, //* 选择器是否只读
    contrast: { type: String, default: '' },
    matchs: { type: Array as PropType<string[]>, default: [] },
    zIndex: { type: Number, default: 66 },
    width: { type: [String, Number] as PropType<number | string>, default: '100%' },
    size: { type: String as PropType<UiTypes.size>, default: "default" },
} as const;

export type UiSelectProps = ExtractPropTypes<typeof UiSelectPropsOption>;

export const UiSelectEmits = {
    "update:modelValue": (_ev: any) => true,
    "change": (_ev?: Event) => true,
};
